module.exports = __webpack_public_path__ + "static/media/WB.2296b95f.jpg";